export enum InvoiceType {
  Standard = 1,
  DebitCorrection = 2,
}
